import eventbus from 'gia/eventbus';
import Component from 'gia/Component'
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'

import Textroll from './textroll'


class Hero extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.speed = 2
    this.isPlaying = false

    this.ref = {
      track: null,
      elm: null
    }
  }

  mount() {
    //  console.log("Mount Hero!");
      this.isPlaying = false
      this.roll = new Textroll(this.element, this.ref)
      this.roll.mount()
      eventbus.on('startHome', this.startHome.bind(this));
      eventbus.on('startGrid', this.startGrid.bind(this));
      eventbus.on('stopGrid', this.stopGrid.bind(this));
      eventbus.on('startProject', this.startProject.bind(this));

      eventbus.on('openContact', this.openContact.bind(this));
      eventbus.on('closeContact', this.closeContact.bind(this));

  }

  startHome(){
    this.play()
    gsap.to(this.ref.track, 2, {opacity:1})
  }
  startProject(){
    gsap.set(this.ref.track, {opacity:1})
  }
  startGrid(){
  //  console.log('startGrid---');
    this.play()
    gsap.to(this.ref.track, 2, {opacity:1})
  }
  stopGrid(){
    this.stop()
  }

  openContact(){

    gsap.to(this.roll.element, .75, {autoAlpha:0, ease:'expo.out'})
    this.wasPlaying = this.isPlaying
    this.wasPlaying && this.stop()
  }

  closeContact(){
    gsap.to(this.roll.element, .75, {autoAlpha:1, ease:'expo.in'})
    this.wasPlaying && this.play()
  }


  stop(){
    this.roll.stop()
    this.isPlaying = false

  }

  play(){
    this.roll.play()
    this.isPlaying = true

  }


  unmount() {
    this.roll.unmount()
    //console.log("Unmount Hero!");
  }


}

module.exports = Hero
